import styled from 'styled-components';

export const FlexedStyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AlignEnd = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;
